import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import { useGlobalStyles } from 'GlobalStyles';
import strings from 'strings';
import { MULTIPLE_SELECTION_TYPES } from 'UI/constants/defaults';
import { formatNumber } from 'UI/utils';

const RESUMES_LIST_COPIES = strings.resumeSearch.resumesList;

export const SelectionHeader = ({
  action,
  totalResults,
  totalSelected,
  itemsOnPage,
  areSomeSelected,
  allOnPageSelected,
  onSelectionChange
}) => {
  const globalClasses = useGlobalStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenMenu = e => setAnchorEl(e.currentTarget);
  const handleCloseMenu = () => setAnchorEl(null);

  const handleSelectMenuItem = selectionType => () => {
    handleCloseMenu();
    onSelectionChange(selectionType);
  };

  const getTotalSelected = () => {
    return strings.formatString(RESUMES_LIST_COPIES.selection.selectedCount, {
      count: formatNumber(totalSelected)
    });
  };

  const getTotalResults = () => {
    return strings.formatString(RESUMES_LIST_COPIES.results, {
      totalResults: formatNumber(totalResults)
    });
  };

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
      <Box display="flex" alignItems="center">
        <Checkbox
          checked={allOnPageSelected}
          indeterminate={areSomeSelected && !allOnPageSelected}
          onClick={handleOpenMenu}
          color="primary"
        />
        <Menu
          id="resume-selection-menu"
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left'
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left'
          }}
          anchorEl={anchorEl}
          getContentAnchorEl={null}
          open={!!anchorEl}
          onClose={handleCloseMenu}
        >
          <MenuItem onClick={handleSelectMenuItem(MULTIPLE_SELECTION_TYPES.page)}>
            {strings.formatString(RESUMES_LIST_COPIES.selection.selectPage, {
              number: formatNumber(itemsOnPage)
            })}
          </MenuItem>
          <MenuItem onClick={handleSelectMenuItem(MULTIPLE_SELECTION_TYPES.all)}>
            {strings.formatString(RESUMES_LIST_COPIES.selection.selectAll, {
              number: formatNumber(totalResults)
            })}
          </MenuItem>
          <Divider className={globalClasses.tightDivider} />
          <MenuItem onClick={handleSelectMenuItem(MULTIPLE_SELECTION_TYPES.unselectAll)}>
            {RESUMES_LIST_COPIES.selection.clearSelection}
          </MenuItem>
        </Menu>
        <Typography variant="body1">
          {areSomeSelected ? getTotalSelected() : getTotalResults()}
        </Typography>
      </Box>
      {areSomeSelected && action ? <Box>{action}</Box> : null}
    </Box>
  );
};
